const transformAuthResponse = (response) => {
    var _a, _b;
    return ({
        isUserLoggedIn: response.IsUserLoggedIn,
        accessToken: {
            accessToken: response.AccessToken.access_token,
            tokenType: response.AccessToken.token_type,
            expiresIn: response.AccessToken.expires_in,
            issued: (_a = response.AccessToken.issued) !== null && _a !== void 0 ? _a : null,
            refreshToken: response.AccessToken.refresh_token,
            salesforceToken: (_b = response.AccessToken.salesforce_token) !== null && _b !== void 0 ? _b : null,
        },
    });
};
export default transformAuthResponse;
